var map = {
	"./locale-provider/bg_BG.tsx": 927,
	"./locale-provider/ca_ES.tsx": 928,
	"./locale-provider/cs_CZ.tsx": 929,
	"./locale-provider/de_DE.tsx": 930,
	"./locale-provider/el_GR.tsx": 931,
	"./locale-provider/en_GB.tsx": 932,
	"./locale-provider/en_US.tsx": 933,
	"./locale-provider/es_ES.tsx": 934,
	"./locale-provider/et_EE.tsx": 935,
	"./locale-provider/fa_IR.tsx": 936,
	"./locale-provider/fi_FI.tsx": 937,
	"./locale-provider/fr_BE.tsx": 938,
	"./locale-provider/fr_FR.tsx": 939,
	"./locale-provider/it_IT.tsx": 940,
	"./locale-provider/ja_JP.tsx": 941,
	"./locale-provider/ko_KR.tsx": 942,
	"./locale-provider/nb_NO.tsx": 943,
	"./locale-provider/nl_BE.tsx": 944,
	"./locale-provider/nl_NL.tsx": 945,
	"./locale-provider/pl_PL.tsx": 946,
	"./locale-provider/pt_BR.tsx": 947,
	"./locale-provider/pt_PT.tsx": 948,
	"./locale-provider/ru_RU.tsx": 949,
	"./locale-provider/sk_SK.tsx": 950,
	"./locale-provider/sr_RS.tsx": 951,
	"./locale-provider/sv_SE.tsx": 953,
	"./locale-provider/th_TH.tsx": 954,
	"./locale-provider/tr_TR.tsx": 955,
	"./locale-provider/vi_VN.tsx": 956,
	"./locale-provider/zh_TW.tsx": 957
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 877;



//////////////////
// WEBPACK FOOTER
// ./components ^\.\/locale-provider\/.+_.+\.tsx$
// module id = 877
// module chunks = 0